import { render } from "./BenefitD.vue?vue&type=template&id=2847001b&scoped=true"
import script from "./BenefitD.vue?vue&type=script&lang=js"
export * from "./BenefitD.vue?vue&type=script&lang=js"

import "./BenefitD.vue?vue&type=style&index=0&id=2847001b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2847001b"]])

export default __exports__